import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  viewBox: "0 0 1445.67 1445.67"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M780.07 238.5h525.98v549.35H780.07zM623.79 813.94h682.26v440.02H623.79zM220.27 662.94h377.6v591.01h-377.6zM155.21 191.72h598.85v445.14H155.21z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }